import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function PictureSection() {
  const images = [
    { id: 1, src: "/up1.png" },
    { id: 2, src: "/pic2.jpg" },
    { id: 3, src: "/pic4.png" },
    { id: 4, src: "/up2.png" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === images.length - 1 ? 0 : prev + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section
      id="picture"
      className="relative w-full bg-[#2D435B] flex items-center justify-center 
                 py-[5vh] sm:py-[5vh] md:py-[12vh] px-[4vw]"
    >
      {/* === Gambar utama === */}
      <div className="relative w-[90%] sm:w-[95%] max-w-[1600px]">
        <img
          src={images[currentIndex].src}
          alt={`Slide ${currentIndex + 1}`}
          className="w-full object-cover h-[35vh] sm:h-[50vh] md:h-[75vh] 
                     rounded-[14px] sm:rounded-[18px] md:rounded-[22px] 
                     shadow-2xl transition-all duration-700 ease-in-out select-none"
        />
      </div>

      {/* === Tombol kiri di ujung biru === */}
      <button
        onClick={prevSlide}
        className="absolute left-4 sm:left-8 lg:left-14 
                   top-1/2 -translate-y-1/2 z-20
                   flex items-center justify-center
                   w-10 h-10 sm:w-12 sm:h-12
                   border border-white/60 text-white
                   rounded-md bg-white/10 hover:bg-white/25
                   transition-all duration-300 shadow-md"
      >
        <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" />
      </button>

      {/* === Tombol kanan di ujung biru === */}
      <button
        onClick={nextSlide}
        className="absolute right-4 sm:right-8 lg:right-14 
                   top-1/2 -translate-y-1/2 z-20
                   flex items-center justify-center
                   w-10 h-10 sm:w-12 sm:h-12
                   border border-white/60 text-white
                   rounded-md bg-white/10 hover:bg-white/25
                   transition-all duration-300 shadow-md"
      >
        <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" />
      </button>
    </section>
  );
}
